<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
           this.route.menuName
        }}</span>
        <span class="masge">当前选项共有{{ total }}条{{this.route.menuName}}</span>
      </div>
      <div class="header">
        <div class="left">

          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
        </div>
        <!-- <div class="right">
          <div class="search">
            <input type="text" v-model="query.keyWord" @change="queryChange" />
            <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i>
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div> -->
      </div>
      <!-- 列表分页栏处理状态 -->
      <!-- <div class="wrapper" width="100" heigth="30">
        <div class="f" v-for="(items) in MessageStateOptions" :key="items.id" @click="wrapperChange(items.value)" :class="{active:items.value==query.state}">
          <el-badge :value="items.number">
            <div class="badge"><a>{{items.name}}</a></div>
          </el-badge>
        </div>
      </div> -->
      <!-- @tab-click="tabClick" -->
      <el-tabs v-model="query.type" stretch @tab-click="tabClick">
        <el-tab-pane name="0" label="待办">
          <span slot="label">
            <el-badge :value="this.unWorkCount" class="item">待办
            </el-badge>
          </span>
        </el-tab-pane>
        <el-tab-pane name="1" label="待阅">
          <span slot="label">
            <el-badge :value="this.unReadCount" class="item">待阅
            </el-badge>
          </span>
        </el-tab-pane>
        <el-tab-pane name="2" label="全部">
          <span slot="label">
            <el-badge :value="this.totalCount" class="item" type="primary">全部
            </el-badge>
          </span>
        </el-tab-pane>
      </el-tabs>

      <!-- <el-radio-group v-model="query.type" @change="queryChange">
        <el-badge :value="this.unWorkCount" class="item">
          <el-radio :label="0" class="f">待办</el-radio>
        </el-badge>
        <el-badge :value="this.unReadCount" class="item">
          <el-radio :label="1" class="f">待阅</el-radio>
        </el-badge>
        <el-badge :value="this.totalCount" class="item" type="primary">
          <el-radio :label="2" class="f">全部</el-radio>
        </el-badge>
      </el-radio-group> -->

      <el-table ref="multipleTable" border :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <!-- <el-table-column align="center" type="selection" fixed width="55">
        </el-table-column> -->
        <el-table-column width="175" prop="tableCodeName" label="所属表单"></el-table-column>
        <el-table-column prop="createdTime" label="创建时间" width="175">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
          </template>
        </el-table-column>
        <el-table-column prop="content" label="内容" @click="toMessageContent(item)"></el-table-column>
        <!-- <el-table-column width="120" prop="stateName" label="状态"></el-table-column> -->

        <el-table-column prop="operation" label="操作" width="120" v-if="query.type != 2">
          <template slot-scope="scope">

            <el-button type="text" v-if="query.type == 0" v-preventReClick @click="toMessageContent(scope.row)" class="margin-left20 color-blue">去处理</el-button>
            <el-button type="text" v-if="query.type == 1" @click="toMessageContent(scope.row)" class="margin-left20 color-blue">标为已阅</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row>
        <el-col :span="2">
          <el-button v-if="query.type==1" size="mini" @click="allRead" type="primary" style="margin-left: 623%;margin-top: 48px;padding: 7px 23px">全部标为已阅</el-button>
        </el-col>
      </el-row>

    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  GetMessages,
  GetMessagesCount,
  ReadedMessage,
  ExportPurchaseOrder,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
// import Info from './info';
import { MessageStateOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";


export default {
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    SelectFilter,
  },
  data () {
    return {
      exportAction: ExportPurchaseOrder,
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        type: '0'
      },
      tabsType: 2,
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      // 打开详情
      showInfo: false,
      id: 0,
      // 多选框数据
      ids: [],
      moduleList: [],
      unWorkCount: 0,
      unReadCount: 0,
      totalCount: 0,
      multipleSelection: [],
      // 列表多选
      multiple: true,
      MessageStateOptions: MessageStateOptions,
      filterOptions: [
        {
          name: "所属表单",
          type: "select",
          code: "tableCodeId",
          filterMethod: this.getModules,
          data: [],
        },
        {
          name: "创建时间",
          type: "date",
          code: "date",
        },
      ],
      showFinishOrderDialog: false,
      finishForm: {},
      finishRules: {
        remark: [
          { required: true, message: "请输入原因", trigger: "blur" },
        ]
      }
    };
  },
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
    },
    // 获取列表
    getData () {
      GetMessages(this.query).then((res) => {
        this.tableData = res.returnData.data;
        this.total = res.returnData.dataCount;
        // this.unWorkCount = res.returnData.unWorkCount;
        // this.unReadCount = res.returnData.unReadCount;
        // this.totalCount = res.returnData.totalCount;
      });
    },
    getMessagesCount () {
      GetMessagesCount().then((res) => {
        this.unWorkCount = res.returnData.unWorkCount;
        this.unReadCount = res.returnData.unReadCount;
        this.totalCount = res.returnData.totalCount;
      });
    },

    wrapperChange (index) {
      this.queryParams.state = index;
      this.getData();
    },

    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },

    // 重置
    reset () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        type: '0',
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.getData();
    },
    queryChange (key) {

      this.query.type = key
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },

    tabClick () {
      // this.$set(this.query, 'appId', id);
      // this.getData();
      this.getData();
    },
    filterChange (query) {
      this.query = Object.assign(this.query, query);
      this.getData();
    },
    // 批量已读
    allRead () {
      if (this.tableData) {
        var ids = this.tableData.map(item => item.id)
        ReadedMessage({ ids: ids })
          .then(res => {
            this.getMessagesCount();
            this.getData();
            this.$my_message(`执行成功`, "success");
          })
      }
    },
    toMessageContent (message) {
      // if (!message.tableCode) {
      //   // 已读消息
      //   ReadedMessage({ ids: [message.id] })
      //   this.getData()
      //   return;
      // }
      console.log(message, "铃铛系统消息message");
      if (message.type == 1) {
        // 已读消息
        ReadedMessage({ ids: [message.id] })
          .then(res => {
            this.getMessagesCount();

            this.getData()
          })

        return;
      }

      let route;
      let editRoute;
      let routes = this.$store.getters.permission_routes;
      for (let i = 0; i < routes.length; i++) {
        if (routes[i].name == message.tableCode) {
          route = routes[i];
          // this.parentRoute = routes[i]
        }
        if (routes[i].name == message.tableCode + "Edit") {
          editRoute = routes[i];
        }

        if (routes[i].children && routes[i].children.length > 0) {
          for (let j = 0; j < routes[i].children.length; j++) {
            if (routes[i].children[j].name == message.tableCode) {
              route = routes[i].children[j];
            }
            if (routes[i].children[j].name == message.tableCode + "Edit") {
              editRoute = routes[i].children[j];
            }
          }
        }
      }

      if (!route) {
        // 已读消息
        ReadedMessage({ ids: [message.id] })
        this.getData()
        return;
      }

      let path = route.path.replace('/', '');
      if (editRoute) {
        path = editRoute.path.replace('/', '')
      }

      if (message.title == "流程审批") {
        this.$router.push("/" + path + "?formMode=3&id=" + message.dataId);
      }
      else {
        // 已读消息
        ReadedMessage({ ids: [message.id] })
        this.$router.push("/" + path + "?formMode=0&id=" + message.dataId);
      }
    }
  },
  created () {
    // 分页组件默认值需要早created
    // if (this.$route.params) {
    //   this.query = this.$route.params
    // }
    this.getModules('');
  },
  mounted () {
    // 查询组件默认值需要在mounted
    // if (this.$route.params) {
    //   this.$refs["selectFilter"].query = this.query
    // }
    this.getData();
    this.getMessagesCount();
    var that = this
    // 定时器 刷新提醒数量
    window.setInterval(function () {
      that.getMessagesCount()
    }, 1000 * 60 * 5)

  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  overflow: hidden;
  zoom: 1;
  margin-top: 1px;
}

.f {
  width: 100px;
  height: 35px;
  color: black;
  float: left;
  margin-top: 10px;
  text-align: center;
  margin: 10px 10px 0;
}
.badge {
  float: left;
  margin: 2px 8px 1px 2px;
  font-size: 14px;
}
.item {
  margin-top: 3px;
  // margin-right: 65px;
  font-size: 16px;
  text-align: center;
}
/deep/.el-badge__content.is-fixed {
  top: 6px;
  right: 2px;
}

.el-tabs {
  width: 500px;
  margin-bottom: 10px;
}
</style>
